import React, { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Projects from './components/Projects';
import Portfolio from './components/Portfolio';
import DesignPower from './components/DesignPower';
import Clients from './components/Clients';
import Notice from './components/Notice';
import Footer from './components/Footer';
import './App.css';

function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="app-container">
      <Header />
      <Hero />
      <Services />
      <Projects />
      <Portfolio />
      <DesignPower />
      <Clients />
      <Notice />
      <Footer />
    </div>
  );
}

export default App;